import * as React from 'react';
import { Switch, Route, withRouter } from 'react-router';
import 'antd/dist/antd.less';
import App from './App';
import Login from './components/pages/Login';
import { getTheme } from './actions/loadInitialData';
import { connect } from 'react-redux';
import injectSheet from 'react-jss';
import Logout from './components/pages/Logout';
import ContainerDetailsMainPage from './components/pages/Container/ContainerDetailsMainPage';
const rippleLoader = require('./assets/images/ripple_loader.gif');
import ErrorIcon from 'src/components/common/icons/ErrorIcon';
import LoginFromInternal from './components/pages/LoginFromInternal';
import { getLoginRoute } from './routing/utils';
import { storeClientDeviceLocation } from './api/utils';

const styles = (theme: any) => ({
  loaderImage: {
    width: '100px',
    height: '100px',
  },
  loaderContainer: {
    width: '100%',
    height: '100%',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingText: {
    fontWeight: '700',
    fontSize: '18px',
    animation: `3s MainLoadingTextAnimationColor alternate infinite,
    3s MainLoadingTextAnimationScale ease alternate infinite`,
    color: '#1aafd0',
  },
  '@keyframes MainLoadingTextAnimationColor': {
    from: { color: '#3be8b0' },
    to: { color: '#1aafd0' },
  },
  '@keyframes MainLoadingTextAnimationScale': {
    '100%': { transform: 'scale(1.1)' },
  },
});
class Main extends React.PureComponent<any, any> {
  state: any = {
    isLoaded: true,
    error: null,
  };

  async componentDidMount() {
    const { dispatch } = this.props;
    await dispatch(getTheme());

    // collect client location 
    storeClientDeviceLocation()
    
    // const fileNameStatus = {
    // tslint:disable-next-line: max-line-length
    //   filename: 'https://s3.ap-south-1.amazonaws.com/shipper-dashboard-public-files/demo/css/demo/demo.0acad9c874fe821c2a5b5625e4929aafcf7953f6715f023a109a82288127b138.css',
    //   isSuccess: true,
    //   errorMessage: '',
    // };
    // if (fileNameStatus.isSuccess) {
    //   const link = document.createElement('link');
    //   const organisationId = getAuthenticationHeaders()['organisation-id'];
    //   link.href = fileNameStatus.filename;
    //   link.type = 'text/css';
    //   link.rel = 'stylesheet';
    //   if (link.addEventListener) {
    //     link.addEventListener('load', () => {
    //       this.setState({ isLoaded: true, error: false });
    //     }, false);
    //   }
    //   const head = document.getElementsByTagName('head')[0];
    //   const customDomStyle = document.getElementById('custom-dom-style');
    //   head.insertBefore(link, customDomStyle);
    // } else {
    //   this.setState({
    //     isLoaded: true, error: fileNameStatus.errorMessage ||
    //       'Something went wrong',
    //   });
    // }
  }

  public render() {
    const { classes } = this.props;
    return this.state.isLoaded ? (
      this.state.error ? (
        <div
          style={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            color: '#EC544A',
            fontSize: '16px',
            height: '100%',
          }}
        >
          <ErrorIcon style={{ fontSize: 104 }} />
          <div
            style={{
              paddingTop: 20,
              color: '#262626',
              fontSize: 28,
              fontWeight: 600,
            }}
          >
            Error
          </div>
          <div style={{ fontSize: 16, color: '#262626', paddingTop: 8 }}>{this.state.error}</div>
        </div>
      ) : (
        <Switch>
          <Route path="/signinFromInternal" component={LoginFromInternal} />
          <Route path="/p/:shipmentType/:unique_id" component={ContainerDetailsMainPage} />
          <Route path={getLoginRoute()} component={Login} />
          <Route path="/logout" component={Logout} />
          <Route component={App} />
        </Switch>
      )
    ) : (
      <div className={classes.loaderContainer}>
        <div style={{ textAlign: 'center' }}>
          <img src={rippleLoader} className={classes.loaderImage} />
          <div className={classes.loadingText}>{''}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default withRouter(connect(mapStateToProps)(injectSheet(styles)(Main)));
